import React from 'react';
import { Box,Grid, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';
import logo from './images/logo.png'
const HomeCourses = () => {
  return (
    <Box sx={{ padding: '30px', backgroundColor: '#f9f9f9', fontFamily: 'Arial, sans-serif', maxWidth: '1200px', margin: '0 auto', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
      {/* Course Title */}
     
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
        Banksmen Safety Course
      </Typography>
      <Grid item xs={12} md={4}>
          <Box component="logo" src="logo.png" alt="Banksmen Safety" sx={{ width: '100%', borderRadius: '10px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }} />
        </Grid>
      {/* Learning Outcome */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Learning Outcome
      </Typography>
      <Typography paragraph>
        At the end of the programme, you will be able to:
      </Typography>
      <List>
        <ListItem><ListItemText primary="Gain awareness of what is a banksman in workplace transport supervision" /></ListItem>
        <ListItem><ListItemText primary="Understand the necessity and importance of a banksman in workplace safety" /></ListItem>
        <ListItem><ListItemText primary="Learn how a banksman helps in risk control for large vehicles" /></ListItem>
        <ListItem><ListItemText primary="Understand the importance of a traffic marshal in traffic control" /></ListItem>
      </List>

      <Divider sx={{ my: 3 }} />

      {/* For Whom */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        For Whom
      </Typography>
      <Typography paragraph>
        The “Banksmen Safety Course” is for anyone that wishes to carry out generic Banksman Duties at the workplace.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Assumed Skills Knowledge / Entry Requirement */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Assumed Skills Knowledge / Entry Requirement
      </Typography>
      <List>
        <ListItem><ListItemText primary="Learners must be above 18 years of age and are assumed to:" /></ListItem>
        <ListItem><ListItemText primary="Have a basic knowledge of vehicle Safety" /></ListItem>
        <ListItem><ListItemText primary="Be able to listen and speak English at a proficiency level equivalent to ES level 2 (Applies to English Courses ONLY)" /></ListItem>
        <ListItem><ListItemText primary="Be able to read and write English at a proficiency level equivalent to ES level 2 (Applies to English Courses ONLY)" /></ListItem>
        <ListItem><ListItemText primary="Be able to manipulate numbers at a proficiency level equivalent to ES level 2" /></ListItem>
        <ListItem><ListItemText primary="Be medically fit" /></ListItem>
      </List>

      <Divider sx={{ my: 3 }} />

      {/* Course Overview */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Course Overview
      </Typography>
      <Typography paragraph>
        Training in safe systems of work, duty of care to new banksmen, employee competence, use of visibility aids and audible alarms, 
        verbal signals and radio systems, personal protective equipment (PPE), high visibility clothing, protective equipment for the head, 
        and weather protection.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Duration */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Duration
      </Typography>
      <Typography paragraph>Total: 4 hours</Typography>

      <Divider sx={{ my: 3 }} />

      {/* Teaching Method */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Teaching Method
      </Typography>
      <Typography paragraph>Face to face classroom training</Typography>

      <Divider sx={{ my: 3 }} />

      {/* Class Size */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Class Size
      </Typography>
      <Typography paragraph>20pax</Typography>

      <Divider sx={{ my: 3 }} />

      {/* Course Attendance */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Course Attendance
      </Typography>
      <Typography paragraph>100% for classroom</Typography>

      <Divider sx={{ my: 3 }} />

      {/* Certification */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Certification
      </Typography>
      <Typography paragraph>
        Jurong Academy will issue safety passes to every candidate who has attended and passed the assessment.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Payment Modes */}
      <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#1976D2' }}>
        Payment Modes
      </Typography>
      <Typography paragraph>Available payment options include:</Typography>
      <List>
        <ListItem><ListItemText primary="Cash/Nets at any of our 3 branches" /></ListItem>
        <ListItem><ListItemText primary="PayNow to UEN 201110331W" /></ListItem>
        <ListItem><ListItemText 
          primary={
            <span>
              Bank Transfer/GIRO details as below:
              <ul>
                <li><strong>BANK NAME:</strong> United Overseas Bank Limited</li>
                <li><strong>ACCOUNT NUMBER:</strong> 450-302-829-2</li>
                <li><strong>ACCOUNT HOLDER:</strong> Jurong Academy Pte Ltd</li>
                <li><strong>BANK CODE:</strong> 7375</li>
                <li><strong>BRANCH CODE:</strong> 001</li>
                <li><strong>SWIFT CODE:</strong> UOVBSGSGXXX</li>
              </ul>
            </span>
          } />
        </ListItem>
      </List>
      <Typography paragraph>
        Please remember to indicate the booking number at the remarks column when payment is made by PayNow, Bank Transfer, and/or GIRO.
      </Typography>

      <Typography paragraph>
        All payments can be made on the day of course commencement at the reception counter. We do not accept foreign cheques and money orders.
      </Typography>
    </Box>
  );
};

export default HomeCourses;
